import Badge from 'components/shared/Badge/Badge';
import Disclosure from 'components/shared/Disclosure/Disclosure';
import Typography from 'components/shared/Typography/Typography';
import { patientPortionOptions } from 'components/practice/Settings/components/HealthcareProgram/components/PaymentProgramTab/components/PaymentSettings/components/PerPhaseConfiguration/components/OutOfNetwork/lib/helpers';

const PatientPortionCpt = ({ value, onChange }) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <Typography variant="label" size="large" weight="medium">
          Patient portion per CPT code
        </Typography>
        <Typography variant="p" size="small">
          In your Schedule of Fees, this is the dollar amount that will be used as the
          out-of-network price for that service.
        </Typography>
      </div>
      <div className="flex flex-col gap-2">
        {patientPortionOptions.map((option) => {
          const isActive = option.value === value;
          return (
            <Disclosure
              key={option.value}
              isOpen={isActive}
              onToggle={() => onChange(option.value)}
              customTitle={
                <div className="flex gap-2">
                  <Typography variant="p" size="small" weight="medium">
                    {option.title}
                  </Typography>
                  {option.recommended && (
                    <Badge text="Recommended" variant="lighter" color="primary" size="small" />
                  )}
                </div>
              }
              disableOpen
              caption={option.caption}
              className="w-full"
              buttonClassName="py-2"
              bodyClassName="flex-col gap-0"
              radio
            />
          );
        })}
      </div>
    </div>
  );
};

export default PatientPortionCpt;
